const siteConfig = {
  brandName: "tastevani",
  displayName: "tastevani",
  initials: "T",
  companyName: "HE FEI SHI HUAN NIE DIAN ZI SHANG WU YOU XIAN GONG SI",
  description:
    "A curated selection of contemporary footwear for everyday wear, offered in a variety of materials and silhouettes.",
  announcement: "Free delivery on orders over £200",
  email: "finance@tastevani.fashion",
  address: "Room 709, Building 19, Wisdom Mansion, Southwest Corner of Linquan East Road and Guangde Road, Longgang Comprehensive Economic Development Zone, Yaohai District, Hefei City, Anhui Province",
  currency: "GBP",
  locale: "en-GB",
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 0,
  }).format(value);

export default siteConfig;
